// Angular imports
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

// Import utils
import { PercentUtils } from '../../utils';

@Component({
    selector: 'percent-input',
    templateUrl: './percent-input.component.html',
    styleUrls: ['./percent-input.component.scss'],
    standalone: false
})
export class PercentInputComponent implements OnInit {
    @Input() public value: number = null;
    @Input() public readonly: boolean = false;

    @Output() public valueChange = new EventEmitter<number>();

    @Output() public onFocus = new EventEmitter<void>();
    @Output() public onBlur = new EventEmitter<void>();

    @ViewChild('input') private inputElement: ElementRef;

    constructor() { }

    public ngOnInit(): void {

    }

    /**
 * Focuses the input's content
 * @returns void
 */
    public focus(): void {
        this.inputElement.nativeElement.focus();
    }

    /**
     * Blurs the input's content (if it has focus)
     * @returns void
     */
    public blur(): void {
        this.inputElement.nativeElement.blur();
    }

    /**
     * Selects the input's content
     * @returns void
     */
    public select(): void {
        this.inputElement.nativeElement.select();
    }

    /* --- Event handlers --- */

    public _handleFocus() {
        this.select();

        this.onFocus.emit();
    }

    public _handleBlur() {
        this.onBlur.emit();
    }

    public async _handleModelChange(value: string) {
        // Unformat the currency
        const unformattedValue = PercentUtils.unformat(value);

        // If the value is the same, clear the current value
        if (unformattedValue === this.value)
            await this.clearValue();

        // Assign the value
        this.value = unformattedValue;

        // Emit change event
        this.valueChange.emit(this.value);
    }

    public _purgeEvent(event: Event) {
        event.stopPropagation();
    }

    private async clearValue() {
        this.value = this.value === null ? 0 : null;
        return new Promise(resolve => {
            setTimeout(resolve, 0);
        });
    }
}
